(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-investor-feed]').forEach(feed => {
      if (feed.dataset.demoBound === 'true') return;
      const tabList = feed.querySelector('[data-card-tabs]');
      const tabs = Array.from(feed.querySelectorAll('[data-card-tab]'));
      const panels = Array.from(feed.querySelectorAll('[data-card-panel]'));
      if (!tabList || !tabs.length || tabs.length !== panels.length) return;
      feed.dataset.demoBound = 'true';
      tabList.setAttribute('role', 'tablist');
      tabList.setAttribute('aria-orientation', 'vertical');
      const selectCard = (index, focus = false) => {
        tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panels[position].hidden = !selected;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', event => {
          event.preventDefault();
          selectCard(index);
          if (window.matchMedia('(max-width: 749px)').matches) {
            panels[index].scrollIntoView({ block: 'start', behavior: 'auto' });
          }
        });
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key === ' ') next = index;
          else return;
          event.preventDefault();
          selectCard(next, true);
        });
      });
      panels.forEach((card, index) => {
        const result = card.querySelector('[data-demo-result]');
        const choices = card.querySelectorAll('[data-demo-choice]');
        choices.forEach(button => {
          button.disabled = false;
          button.addEventListener('click', () => {
            const message = result?.dataset[button.dataset.demoChoice];
            if (!message) return;
            choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
            result.textContent = message;
            const state = tabs[index].querySelector('[data-demo-selection-state]');
            if (state) {
              state.textContent = button.textContent.trim();
              state.hidden = false;
            }
          });
        });
      });
      selectCard(0);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
